import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import FlujoEdPNoRFA from './FlujoEdP/FlujoEdPNoRFA';
import FlujoEdPRFA from './FlujoEdP/FlujoEdPRFA';
import ResultadoEdP from './ResultadoEdp';
import InformationEdP from './InformationEdP';
import '../style.css';
import { useSelector } from 'react-redux';
import { useGetHeaderEP } from '../../../hooks/services/sPay/useOfEdPPrepare';
import FlujoEdPRFADynamicApprove from './FlujoEdP/FlujoEdPRFADynamicApprove';
import FlujoEdPNoRFADynamicApprove from './FlujoEdP/FlujoEdPNoRFADynamicApprove';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../common/Dictionaries';
import { useGetUserPropsKpi } from '../../../hooks/services/sPrivilege/useOfPrivilege';

export default function PrepareEdP(props) {

    const [queryStringElementId, setQueryStringElementId] = useState(
        props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ?
            props.match.params.elementId : null);

    const [queryStringEdPId, setQueryStringEdPId] = useState(
        props.match.params.edpId !== null && props.match.params.edpId !== undefined && props.match.params.edpId !== "" ?
            props.match.params.edpId : null);

    const {
        _edpPrepareHeader: edpPrepareHeader,
        _forceGet_PrepareHeader: forceGet_PrepareHeader,
    } = useSelector((state) => state.edpPreparationState);
    
    useGetHeaderEP(queryStringElementId, queryStringEdPId, edpPrepareHeader, forceGet_PrepareHeader)

    const { token: currentAuth } = useSelector((state) => state.auth);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.EDP;
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(BoardTypeId, null, queryStringElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)

    return (
        <Row>
            <Col>
                <Row>
                    <Col className='col-auto ms-auto p-1 ps-3 pb-2'>
                    {
                        edpPrepareHeader &&
                        <FlujoEdPRFADynamicApprove
                            inputParam_ComponentWidth={
                                edpPrepareHeader && edpPrepareHeader.l_etapas_revision.filter(x => x.revisionDinamica === true).length === 0 ?
                                (edpPrepareHeader.cantidad_rfa === 0 ? '560px' : '700px') :
                                (edpPrepareHeader.cantidad_rfa === 0 ? '860px' : '980px')
                            }
                        />
                    }
                    </Col>
                    <Col className='p-1 pe-3 pb-2'>
                    {
                        edpPrepareHeader &&
                        <InformationEdP inputParam_UserPropsKpi={userPropsKpi} inputParam_ElementId={queryStringElementId} inputParam_EdPId={queryStringEdPId} />
                    }
                    </Col>
                </Row>
                <Row>
                    <Col className='px-3'><ResultadoEdP inputParam_UserPropsKpi={userPropsKpi} inputParam_ElementId={queryStringElementId} inputParam_EdPId={queryStringEdPId} /></Col>
                </Row>
            </Col>
        </Row>
    );
};
